import { FC, useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';
import BasicModal from '__components/Modals/presets/BasicModal';
import DateTimeInput from '__components/Inputs/DateTimeInput';
import Cols from '__components/Layout/Cols';

type CreateScheduleModalProps = {
  onConfirm: (date: Date) => void;
  onHide: () => void;
};

export const CreateScheduleModal: FC<CreateScheduleModalProps> = ({
  onConfirm,
  onHide,
}) => {
  const { t } = useTranslation();
  const [date, setDate] = useState(new Date());

  const handleSubmit = useCallback(() => {
    onConfirm(date);
  }, [onConfirm, date]);

  return (
    <BasicModal
      size="medium"
      show
      onConfirm={handleSubmit}
      onHide={onHide}
      heading={t('Sample Scheduled Trigger')}
    >
      <Cols columns={3}>
        <DateTimeInput
          label={t('Trigger Time')}
          value={date}
          onChange={setDate}
          margin
          portal
        />
      </Cols>
    </BasicModal>
  );
};
